import {
  Button,
  ButtonProps,
  Typography,
  TypographyProps,
} from '@mui/material';
import { ExternalIcon } from 'modules/common/icons';
import {
  getExplorerLink,
  TLinkType,
} from 'modules/common/utils/getExplorerLink';
import { ShortenedAddress } from '../ShortenedAddress';

interface ITxExplorerLinkProps {
  txId: string;
  network: string | number;
  typographyProps?: TypographyProps;
  buttonProps?: ButtonProps;
  type?: TLinkType;
  iconSize?: number;
}

export const TxExplorerLink = ({
  txId,
  network,
  typographyProps = {},
  buttonProps = {},
  type = 'tx',
  iconSize = 24,
}: ITxExplorerLinkProps) => {
  return (
    <Button
      component="a"
      href={getExplorerLink(txId, network, type)}
      target="_blank"
      rel="norefferer"
      endIcon={
        <ExternalIcon
          style={{
            width: iconSize,
            height: iconSize,
          }}
        />
      }
      {...buttonProps}
      sx={{
        px: 0,
        ...buttonProps?.sx,
      }}
    >
      <Typography {...typographyProps}>
        <ShortenedAddress address={txId} />
      </Typography>
    </Button>
  );
};
